import useViewport from '@shared/innmaxLib/hooks/useViewport'
import { Select } from 'antd'
import { SelectProps as AntSelectProps, SelectValue } from 'antd/lib/select'
import React from 'react'
import styled from 'styled-components'
import MobileSelect from './MobileSelect'

interface StyledSelectProps<T = SelectValue> extends AntSelectProps<T> {
  forwardRef?: React.Ref<any>
  ref?: any
}

export interface SelectProps<T = SelectValue> extends StyledSelectProps<T> {
  render?: (values: any) => any
  useForm?: boolean
}

const StyledSelect: any = styled(Select)`
  &.ant-select {
    .ant-select-clear {
      background: transparent !important;
    }
    & svg[data-icon='close-circle'] {
      fill: ${p => p.theme.select.clearIconFill};
    }
    & svg[data-icon='down'] {
      fill: ${p => p.theme.select.arrowDownIconFill};
    }
    &.ant-select-disabled.ant-select:not(.ant-select-customize-input)
      .ant-select-selector {
      background: ${p => p.theme.select.disabledBg};
    }
    &.ant-select-status-error {
      .ant-select-selector {
        background-color: ${p => p.theme.select.bg} !important;
      }
    }
    .ant-select-selector {
      border-radius: 4px;
      background: ${p => p.theme.select.bg};
      color: ${p => p.theme.select.color};
      border-color: ${p => p.theme.select.borderColor};
      &:hover,
      &:active,
      &:focus {
        border-color: ${p => p.theme.select.hoverAndFocusBorderColor};
      }
      & .ant-select-selection-placeholder {
        color: ${p => p.theme.select.placeholderColor};
      }
    }
    .ant-select-selection-item-content {
      color: ${p => p.theme.select.tagColor};
    }

    .ant-select-arrow-icon {
      position: relative;
      top: -1px;
      font-size: 14px;
    }

    &.selection__multiple-items--hide
      .ant-select-selection--multiple
      .ant-select-selection__choice__disabled {
      display: none;
    }
  }
`

class DesktopSelect<T = any> extends React.Component<
  StyledSelectProps<T>,
  any
> {
  public static Option = Select.Option

  public static OptionGroup = Select.OptGroup

  public static displayName = 'DesktopSelect'

  render() {
    const { forwardRef, ...others } = this.props
    return (
      <StyledSelect ref={forwardRef} {...others}>
        {this.props.children}
      </StyledSelect>
    )
  }
}

interface SelectComponentType {
  <T = SelectValue>(
    props: StyledSelectProps<T> & React.RefAttributes<any>
  ): React.ReactElement | null
  Option: typeof Select.Option
  OptionGroup: typeof Select.OptGroup
  displayName?: string
}

const SelectComponent = React.forwardRef<any, StyledSelectProps>(
  ({ children, ...props }, ref) => {
    const { isMobile } = useViewport()

    if (isMobile) {
      return <MobileSelect {...props}>{children}</MobileSelect>
    }

    return (
      <DesktopSelect forwardRef={ref} {...props}>
        {children}
      </DesktopSelect>
    )
  }
) as unknown as SelectComponentType

SelectComponent.Option = Select.Option
SelectComponent.OptionGroup = Select.OptGroup
SelectComponent.displayName = 'Select'

export default SelectComponent

export { SelectComponent as Select }
